import './styles/index.less';

import 'lib/sock-js';
import 'lib/socket-redis';
import {siteUrl} from "../../../core/utils/url";
import {lang} from "../../../core/utils/lang"
import {Notifier} from "../../../core/widgets/notifier";
import loading from "../../../core/widgets/loading";
import {registerGlobalFunctions} from "../common/global_functions";

const selectedIds = [];
const customFilters = [];
let loadedRecords = null;
let $tblLots = null;
let automaticDataTracking = true;

export function init(options) {
    const o = {
        isAlena: false,
        carId: false,
        similarity: false,
        yearsRange: {min: 0, max: 0},
        featureColumns: [],
        notificationChannelUrl: false,
        ...options
    };

    automaticDataTracking = !o.isAlena;

    initGrid(o.isAlena, o.carId, o.similarity, o.yearsRange, o.featureColumns);
    initTimers();
    initDataTracking(o.notificationChannelUrl);
    registerGlobalFunctions();
    if(o.isAlena) {
        initCompareCheckedButton();
        initHideButton();
        initExportButton();
        initAutomaticUpdateInputCheckbox();
        initScrollLinks();
    }
}

function initGrid(isAlena, carId, similarity, yearsRange, featureColumns) {
    $(function(){
        const colNames = [
            lang('hdr_lpa_make_and_model'),
            lang('hdr_lpa_car_type'),
            lang('hdr_lpa_details'),
            lang('hdr_lpa_gear_type'),
            lang('hdr_lpa_horse_power'),
            lang('hdr_lpa_total_mileage'),
            lang('hdr_lpa_first_registration_date'),
            lang('hdr_lpa_current_highest_bid'),
            lang('hdr_lpa_similar'),
            lang('hdr_lpa_very_similar'),
            'Кол-во похожих',
            'Min цена похожих',
            'Max цена похожих',
            'Средняя цена похожих',
            'Медиана цены похожих',
            lang('hdr_lpa_end_date'),

            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            ''
        ];
        const colModel = [
            {name: 'make_and_model', width: isAlena ? 200 : 100, align: 'center', template:'#lpaImageTemplate',
                cellattr: emptyTitleCellAttr},
            {name: 'car_type', width: isAlena ? 100 : 80, align: 'center', template: '#lpaTitleTemplate',
                cellattr: emptyTitleCellAttr},
            {name: 'details', width: isAlena ? 150 : 80, align: 'center', template: '#lpaDetailsTemplate',
                sortable: false, cellattr: emptyTitleCellAttr},
            {name: 'gear_type', width: isAlena ? 76 : 34, align: 'center', template: '#lpaNullableTemplate',
                cellattr: emptyTitleCellAttr},
            {name: 'horse_power', width: isAlena ? 50 : 40, align: 'center', sorttype: 'int', template: '#lpaNullableTemplate',
                cellattr: emptyTitleCellAttr},
            {name: 'total_mileage_value', width: isAlena ? 86 : 46, align: 'center', sorttype: 'int', template: '#lpaNullableTemplate',
                rangeSearch: true, cellattr: emptyTitleCellAttr},
            {name: 'first_registration_date', width: isAlena ? 120 : 60, align: 'center',
                template: '#lpaFirstRegistrationDateTemplate', rangeSearch: true, stype: 'select',
                searchoptions: {value: getYearsSelectOptions(yearsRange)},
                cellattr: emptyTitleCellAttr

            },
            {name: 'current_highest_bid', width: isAlena ? 110 : 60, align: 'center', sorttype: 'float',
                template: '#lpaCurrentHighestBid',
                cellattr: emptyTitleCellAttr
            },
            {name: 'min_diff_1', width : isAlena ? 80 : 60, align: 'center', template: '#lpaMinDiff1', search: false,
                cellattr: emptyTitleCellAttr},
            {name: 'min_diff_2', width : isAlena ? 80 : 60, align: 'center', template: '#lpaMinDiff2', search: false,
                cellattr: emptyTitleCellAttr},
            {name: 'similar_cars_count_1', hidden: !isAlena, width: 50, align: 'center', classes: 'col-highlight-a',
                cellattr: emptyTitleCellAttr},
            {name: 'similar_cars_bid_min_1', hidden: !isAlena, width: 65, align: 'center', classes: 'col-highlight-a',
                template: '#lpaNullableTemplate', cellattr: emptyTitleCellAttr},
            {name: 'similar_cars_bid_max_1', hidden: !isAlena, template: '#lpaNullableTemplate', width: 65,
                classes: 'col-highlight-a', align: 'center', cellattr: emptyTitleCellAttr},
            {name: 'similar_cars_bid_avg_1', hidden: !isAlena, template: '#lpaNullableTemplate', width: 65,
                classes: 'col-highlight-a', align: 'center', cellattr: emptyTitleCellAttr},
            {name: 'similar_cars_bid_median_1', hidden: !isAlena, template: '#lpaNullableTemplate', width: 65,
                classes: 'col-highlight-a', align: 'center', cellattr: emptyTitleCellAttr},
            {name: 'seconds_to_close', width: isAlena ? 120 :80, align: 'center', stype: 'select', sortable: true,
                template: '#lpaSecondsToClose',
                searchoptions: {value:':Все;active:Текущие;active_1_hour:Текущие (в теч. 1 часа);active_30_minutes:Текущие (в теч. 30 минут);active_5_minutes:Текущие (в теч. 5 минут);today:Сегодня;tomorrow:Завтра;closed:Оконченные'},
                cellattr: emptyTitleCellAttr
            },

            {name: 'id', hidden: true},
            {name: 'auction_type', hidden: true},
            {name: 'main_image_url', hidden: true},
            {name: 'report_url', hidden: true},
            {name: 'last_update', hidden: true},
            {name: 'first_registration_date_human', hidden: true},
            {name: 'auction_end_date_time', hidden: true},
            {name: 'auction_end_date_time_human', hidden: true},
            {name: 'similar_cars_description_1', hidden: true},
            {name: 'similar_cars_description_2', hidden: true},
            {name: 'similar_cars_count_2', hidden: true},
            {name: 'similar_cars_bid_min_2', hidden: true},
            {name: 'similar_cars_bid_max_2', hidden: true},
            {name: 'similar_cars_bid_avg_2', hidden: true},
            {name: 'similar_cars_bid_median_2', hidden: true}
        ];

        if(isAlena) {
            colNames.push(
                '',
                'Аукцион',
                '<span class="checked-cars-count" rel="checked-cars-count">0</span>',
                lang('hdr_lpa_nr_of_doors'),
                lang('hdr_lpa_nr_of_seats'),
                lang('hdr_lpa_emission_class')
            );
            colModel.push(
                {name: 'has_damage_reports', template: '#lpaControlsTemplate', width: 124, align: 'center',
                    stype: 'select', search: true, sortable: false, cellattr: emptyTitleCellAttr, searchoptions:
                    {value: ':Все;0:Нет отчётов о повреждениях;1:Есть отчёты о повреждениях;n-a:Не известно'}},
                {name: 'auction_id', hidden: !isAlena, width: 64, align: 'center', template: '#lpaAuctionTemplate'},
                {name: 'checked', template: '#lpaCheckboxTemplate', width: 30, align: 'center', search: false,
                    sortable: false},
                {name: 'nr_of_doors', width: 50, align: 'center', sorttype: 'int', template: '#lpaNullableTemplate',
                    classes: 'col-highlight-b', cellattr: emptyTitleCellAttr},
                {name: 'nr_of_seats', width: 50, align: 'center', sorttype: 'int', template: '#lpaNullableTemplate',
                    classes: 'col-highlight-b', cellattr: emptyTitleCellAttr},
                {name: 'emission_class', width: 70, align: 'center', sortable: false, template: '#lpaNullableTemplate',
                    classes: 'col-highlight-b',cellattr: emptyTitleCellAttr}
            );

            featureColumns.forEach(featureColumn => {
                colNames.push(featureColumn.title);
                colModel.push({
                    name: featureColumn.name,
                    width: 64,
                    align: 'center',
                    template: featureColumn.is_bool ? '#lpaBoolTemplate' : null,
                    stype: 'select',
                    searchoptions: {value: featureColumn.is_bool
                        ? ':Все;1:Есть;0:Нет'
                        : ':Все;' + featureColumn.values.map(v => `${v.id}:${v.name}`).join(';')
                    },
                    classes: 'col-highlight-b',
                    cellattr: emptyTitleCellAttr
                })
            });

            colNames.push(
                '',
                lang('hdr_lpa_custom_price'),
                lang('hdr_lpa_calculated_price'),
                lang('hdr_lpa_custom_and_calculated_price_diff'),
                lang('hdr_lpa_custom_and_calculated_price_diff_percent'),
                'Mobile.de',
                ''
            );

            colModel.push(
                {name: 'location_city', hidden: true},
                {name: 'custom_price', width: 50, align: 'center', template: '#lpaCustomPriceTemplate',
                    classes: 'col-highlight-c', cellattr: emptyTitleCellAttr},
                {name: 'calculated_price', width: 60, align: 'center', template: '#lpaNullableTemplate',
                    classes: 'col-highlight-c', cellattr: emptyTitleCellAttr},
                {name: 'custom_and_calculated_price_diff', width: 50, align: 'center', template: '#lpaNullableTemplate',
                    classes: 'col-highlight-c', cellattr: emptyTitleCellAttr},
                {name: 'custom_and_calculated_price_diff_percent', width: 50, align: 'center',
                    classes: 'col-highlight-c', template: '#lpaNullableTemplate', cellattr: emptyTitleCellAttr},
                {name: 'mobile_de_data', width: 140, align: 'center', search: false, sortable: false,
                    classes: 'col-highlight-c', template: '#lpaMobileDeTemplate', cellattr: emptyTitleCellAttr},
                {name: 'mobile_de_calculated_price', hidden: true}
            );
        } else {
            colNames.push('');
            colModel.push({name: 'calculated_customer_price', hidden: true});
        }

        $tblLots = $('#tblLots');
        $tblLots.jqGrid({
            url: siteUrl('car-auctions/getItems'),
            postData: {
                car_id: carId,
                similarity
            },
            datatype: 'json',
            mtype: 'post',
            colNames,
            colModel,
            rowNum: 20,
            rowList: [20, 50, 100],
            rownumbers: false,
            pager: '#pgrLots',
            viewrecords: true,
            autowidth: !isAlena,
            height: 'auto',
            ignoreCase: true,
            loadui: 'block',
            sortname: 'seconds_to_close',
            sortorder: 'asc',
            onSelectRow: (rowId) => {
                if(!isAlena) {
                    const data = jqgrid_get_row($tblLots, rowId);
                    if (data.report_url) {
                        window.open(data.report_url, '_blank');
                    }
                }
            },
            serializeGridData: postData => {
                let filters = {groupOp: 'AND', rules: []};

                if(postData._search) {
                    filters = JSON.parse(postData.filters);
                }

                customFilters.forEach(filter => {
                    // Clear old data
                    const orCount = filters.rules.length;
                    for(let i = 0; i < orCount; i++) {
                        if(filters.rules[i].field == filter.field) {
                            filters.rules.splice(i, 1);
                            break;
                        }
                    }

                    switch(filter.type) {
                        case 'range':
                            const fromVal = $(`#gs_${filter.field}_from`).val();
                            const toVal = $(`#gs_${filter.field}_to`).val();

                            if(fromVal || toVal) {
                                filters.rules.push({
                                    field: filter.field,
                                    op: 'ir',
                                    data: {
                                        from: fromVal ? fromVal : null,
                                        to: toVal ? toVal : null
                                    }
                                });
                            }
                            break;
                    }
                });

                if(filters.rules.length > 0) {
                    postData._search = true;
                    postData.filters = JSON.stringify(filters);
                }

                return postData;
            },
            beforeProcessing: data => {
                const count = data.rows.length;
                loadedRecords = [];
                for(let i = 0; i < count; i++) {
                    data.rows[i].checked = (selectedIds.indexOf(data.rows[i].id) !== -1) ? 1 : 0;
                    loadedRecords[data.rows[i].id] = data.rows[i];
                }
            },
            loadComplete: () => {
                updateTimers();
                $('#cbSelectAllItems').triStateCheckbox('update');
            }

        }).jqGrid('filterToolbar', {stringResult: true, searchOnEnter: false, defaultSearch: 'cn'});

        initCustomFilters();

        $tblLots.on('click', '.similar-link', e => {
            e.preventDefault();
            window.open($(e.target).attr('href'));
        });

        $tblLots.on('click', 'input', e => {
            if(!$(e.target).hasClass('select-cb')) {
                e.preventDefault();
            }
        });

        $tblLots.on('change', '.select-cb', e => {
            e.preventDefault();

            const $target = $(e.target);
            const id = $target.val();
            const checked = $target.is(':checked');

            checkItem(id, checked);
            updateCheckedItemsDependencies();
        });

        initMobileDeLinks();
        initCustomPriceInputs();
        initSelectAllCheckbox();
    });
}

function initTimers() {
    setInterval(() => {
        updateTimers();
    }, 1000);
}

function initDataTracking(notificationChannelUrl) {
    const socketRedis = new SocketRedis(notificationChannelUrl);

    socketRedis.onopen = () => {
        socketRedis.subscribe('car_auctions_notifications', null, null, (event, data) => {
            switch(event) {
                case 'data-updated':
                    if(automaticDataTracking) {
                        updateRealTimeData();
                    }
                    break;
            }
        });
    };

    socketRedis.open();
}

function initMobileDeLinks() {
    $tblLots.on('click', '.parse-mobile-de-data', e => {
        e.preventDefault();

        const id = $(e.target).data('id');

        if(id) {
            loading.show();
            $.post(siteUrl('car-auctions/parseMobileDe'), {id}, null, 'json')
                .always(() => loading.hide())
                .then(response => {
                    if(response.success) {
                        const rowData = loadedRecords[id];
                        rowData.mobile_de_data = response.data;
                        jqgrid_set_row($tblLots,  id, rowData);
                    } else {
                        Notifier.error(response.message);
                    }
                })
                .fail(() => Notifier.errorXHR());
        }
    });
}

function initCustomPriceInputs() {
    $tblLots.on('change', '.custom-price-input', e => {
        const $target = $(e.target);
        const id = $target.data('id');
        const val = $target.val();

        if(id && val) {
            loading.show();
            $target.prop('disabled', true);
            $.get(siteUrl('car-auctions/setCustomPrice'), {id, val}, null, 'json')
                .always(() => {
                    $target.prop('disabled', false);
                    loading.hide();
                })
                .then(response => {
                    if(response.success) {
                        const rowData = {...loadedRecords[id], custom_price: val, ...response.data};
                        jqgrid_set_row($tblLots,  id, rowData);

                        Notifier.success('Значение сохранено');
                    } else {
                        Notifier.error('Не удалось сохранить значение');
                    }
                })
                .fail(() => Notifier.errorXHR());
        }
    });
}

function initSelectAllCheckbox() {
    $('.ui-search-toolbar .ui-th-ltr:nth-child(33) div').append(
        $('<span id="cbSelectAllItems">Выбрать все/снять выделение</span>')
    );
    $('#cbSelectAllItems').triStateCheckbox({selector: '.select-cb', context: $tblLots[0]});
}

function initCompareCheckedButton() {
    const $compareCheckedButton = $('.compare-checked-btn');

    $compareCheckedButton.click(e => {
        e.preventDefault();

        if(selectedIds.length) {
            const data = {
                ids: selectedIds,
                jqgrid_filters: jqgrid_get_param($tblLots, 'postData')
            };

            loading.show();
            $compareCheckedButton.prop('disabled', true);
            $.post(siteUrl('car-auctions/getSelectedItemsComparisonUrl'), data, null, 'json')
                .always(() => {
                    loading.hide();
                    updateCheckedItemsDependencies();
                })
                .then(response => {
                    if(response.success) {
                        window.open(response.url, '_blank');
                    } else {
                        Notifier.error();
                    }
                })
                .fail(() => Notifier.errorXHR());
        } else {
            Notifier.error('Не выбрано ниодной машины');
        }
    });
}

function initHideButton() {
    const $hideCheckedButton = $('.hide-checked-btn');

    $hideCheckedButton.click(e => {
        e.preventDefault();

        if(selectedIds.length) {
            const data = {
                ids: selectedIds,
                jqgrid_filters: jqgrid_get_param($tblLots, 'postData')
            };

            loading.show();
            $hideCheckedButton.prop('disabled', true);
            $.post(siteUrl('car-auctions/hideAuction'), data, null, 'json')
                .always(() => {
                    loading.hide();
                })
                .then(response => {
                    if(response.success) {
                        while(selectedIds.length) $affectedIds.pop();
                        updateCheckedItemsDependencies();
                        $tblLots.trigger("reloadGrid");
                    } else {
                        Notifier.error('Не удалось скрыть выбранные лоты');
                    }
                })
                .fail(() => {
                    updateCheckedItemsDependencies();
                    Notifier.errorXHR()
                });
        } else {
            Notifier.error('Не выбрано ниодной машины');
        }
    });
}

function initExportButton() {
    $('.export-as-csv-btn').click(e => {
        e.preventDefault();

        $('<form />')
            .attr('action', siteUrl('car-auctions/exportCsv'))
            .attr('method', 'post')
            .attr('target', '_blank')
            .hide()
            .appendTo('body').submit();
    });
}

function initScrollLinks() {
    $('#scrollToTopLink').click(() => {
        window.scrollTo(0, $('.content').position().top);
    });

    $('#scrollToBottomLink').click(() => {
        window.scrollTo(0, document.body.scrollHeight - $('footer').outerHeight() - 400);
    });
}

function initCustomFilters() {
    const colModel = jqgrid_get_param($tblLots, 'colModel');

    colModel.forEach(col => {
        const colProps = jqgrid_get_col_props($tblLots, col.name);

        if(colProps.rangeSearch !== undefined && colProps.rangeSearch) {
            const $control = $(`#gs_${col.name}`)
                .css('width', '50%')
                .css('display', 'inline-block')
                .attr('name', `${col.name}[]`)
                .attr('id', `gs_${col.name}_from`);
            const $controlClone = $control.clone()
                .attr('id', `gs_${col.name}_to`);

            if($control.is('input')) {
                $control.attr('placeholder', 'От');
                $controlClone.attr('placeholder', 'До')
                    .on('change keyup paste', e => {
                        const $element = $(e.target);

                        // Prevent multiple calls
                        if(!$element.data('pending-changes')) {
                            $element.data('pending-changes', true);

                            setTimeout(() => {
                                $element.data('pending-changes', false);

                                if($element.data('prev-value') !== $element.val()) {
                                    $element.data('prev-value', $element.val());
                                    jqgrid_reload($tblLots);
                                }
                            }, 500);
                        }
                    });
            } else {
                $control.prepend('<option value="" selected>От</option>');
                $controlClone.prepend('<option value="" selected>До</option>')
                    .change(e => jqgrid_reload($tblLots));
            }

            $control.parent().append($controlClone);

            customFilters.push({type: 'range', field: col.name});
        }
    });
}

function initAutomaticUpdateInputCheckbox() {
    const $automaticUpdateCheckbox = $('#automatic-update');

    $automaticUpdateCheckbox.change(() => {
        const enabled = $automaticUpdateCheckbox.is(':checked');

        automaticDataTracking = enabled;
        $('#update-btn').toggle(!enabled);
    });

    initUpdateButton();
}

function initUpdateButton() {
    const $button = $('#update-btn');

    $button.click(() => {
        $button.prop('disabled', true);
        loading.show();
        updateRealTimeData()
            .always(() => {
                loading.hide();
                $button.prop('disabled', false);
            })
            .fail(() => Notifier.errorXHR());
    });
}

function updateRealTimeData() {
    return $.get(siteUrl('car-auctions/getItemsRealTimeData'), response => {
        if(response.success && loadedRecords !== null) {
            const count = response.data.length;
            for(let i = 0; i < count; i++) {
                if(loadedRecords[response.data[i].id] !== undefined) {
                    const rowData = {...loadedRecords[response.data[i].id], ...response.data[i]};
                    jqgrid_set_row($tblLots,  response.data[i].id, rowData);
                }
            }
            updateTimers();
        }
    }, 'json');
}

function updateTimers() {
    if($tblLots !== null) {
        $('.auction-end-counter').each(function() {
            const $this = $(this);
            const diff = Date.parse($this.data('end-date-time')) - Date.parse(new Date());

            if(diff > 0) {
                const seconds = ('0' + Math.floor((diff / 1000) % 60)).slice(-2);
                const minutes = ('0' + Math.floor((diff / 60000) % 60)).slice(-2);
                const hours = ('0' + Math.floor((diff / (3600000)) % 24)).slice(-2);
                const days = Math.floor(diff / 86400000);

                $this.text((days > 0 ? `${days} дн ` : '') + `${hours}:${minutes}:${seconds}`);
            } else {
                jqgrid_set_row($tblLots,  $this.data('id'), {seconds_to_close: -1});
            }
        })
    }
}

function checkItem(id, checked) {
    const index = selectedIds.indexOf(id);
    const inList = index !== -1;

    if(checked && !inList) {
        selectedIds.push(id);
    }
    if(!checked && inList) {
        selectedIds.splice(index, 1);
    }
    jqgrid_set_cell($tblLots, id, 'checked', checked ? 1 : 0);
}

function updateCheckedItemsDependencies() {
    const count = selectedIds.length;

    $("[rel='checked-cars-count']").text(count);
    $("[rel='checked-cars-required']").prop('disabled', count === 0);
}

function emptyTitleCellAttr() {
    return 'title=""';
}

function getYearsSelectOptions(yearsRange) {
    const years = [];

    for(let year = yearsRange.min; year <= yearsRange.max; year++) {
        years.push(year);
    }

    return years.map(year => `${year}:${year}`).join(';');
}


// WEBPACK FOOTER //
// ./modules/car_auctions/list/index.js